<template>
    <CustomizerStepShell
        :builder-content-missing="builderContentMissing"
        :can-show-content="canShowContent"
        :model="model"
        :content="content"
        :api-key="apiKey"
        :custom-components="getRegisteredComponents()"
    />
</template>

<script>
import { captureCustomizerException } from "../../utils/sentry";
import cartMixin from "../../mixins/cartMixin";
import builderIoMixin from "../../mixins/builderIoMixin";
import stepNavigationMixin from "../../mixins/stepNavigationMixin";
import eventBusMixin from "../../mixins/eventBusMixin";
import shareMixin from "../../mixins/shareMixin";
import CustomizerStepShell from "./CustomizerStepShell.vue";

export default {
    name: "StepTwo",
    components: {
        CustomizerStepShell,
    },
    mixins: [cartMixin, builderIoMixin, stepNavigationMixin, eventBusMixin, shareMixin],
    data() {
        return {
            eventListeners: [
                { event: "createStory", handler: this.createStory }
            ]
        };
    },
    mounted() {
        this.initializeBuilderContent("StepTwo")
            .then(() => {
                if (!this.isBuilderIoMode()) {
                    const didRedirect = this.validateAndRedirectToPreviousSteps(
                        this.pageSettings, 
                        "StepTwo"
                    );
                    if (didRedirect) return;
                }
            })
            .catch(error => {
                if (process.env.VUE_APP_DEV_MODE === "true") {
                    console.error("Error initializing StepTwo", {
                        code: error?.code || "unknown",
                    });
                }
                captureCustomizerException(error, {
                    tags: { component: "StepTwo", failure_reason: "step_initialization_failed" },
                });
            });
    },
    methods: {
        createStory() {
            this.handleCreateStoryNavigation();
        },
    },
};
</script>
